import { actionsToArray } from '@noven-prime/lattice-core';
import { siteContentActions } from './actions.js';
/**
 * Site Content Capability Manifest
 *
 * Owns the published site-content document: the editable copy for every
 * public page (hero, services, pricing tiers, about, contact).
 */
export const siteContentManifest = {
    id: 'site-content',
    name: 'Site Content',
    description: 'Edit and publish the content shown on the public website',
    version: '1.0.0',
    surfaces: {
        allowed: '*',
    },
    experiences: {
        allowed: '*',
    },
    actions: actionsToArray(siteContentActions),
    features: [
        {
            id: 'content-editing',
            name: 'Content Editing',
            description: 'Edit and publish site content from the admin area',
            actions: actionsToArray(siteContentActions),
        },
    ],
};
//# sourceMappingURL=manifest.js.map